module.exports = __webpack_public_path__ + "static/media/reducer-todo-min.38e23c24.png";